import Context from './_context';

export default Context.Consumer;
